import * as types from '@/store/types'
import { throwError } from '@/utils/store'
import { toSnakeCaseString } from '@/utils/common'

const sortProps = {
  adGroup: 'network'
}

export default {
  [types.FETCH_ADS]: ({ commit, getters }, {
    name, during, startDate, endDate, page, limit, filterType, sortProp, sortOrder
  }) => {
    const availableTypes = {
      [types.WORST_ADS]: 'worst',
      [types.DISPUTED_ADS]: 'disputable'
    }
    const type = availableTypes[name]
    const sort = sortProps[sortProp] || toSnakeCaseString(sortProp)
    const reverse = sortOrder === 'descending'

    const options = {
      during,
      start_date: startDate,
      end_date: endDate,
      type,
      page,
      limit,
      filter_type: filterType,
      sort,
      reverse
    }

    commit(types.LOADING, name)
    return getters.apiService.fetchAds(options)
      .then(({
        isValidConversions, list, cpl, totalPage
      }) => {
        commit(types.SET_LIST, { name, list })
        commit(types.UPDATE_PARAMS, { name, params: { totalPage, isValidConversions } })
        commit(types.SET_MODULE_PROPERTY, { name, key: 'cpl', value: cpl })
      })
      .catch(throwError(commit, `Ошибка получения списка групп объявлений (${name})`))
      .finally(() => commit(types.LOADED, name))
  },

  [types.CHANGE_ADS_STATUS]: ({ commit, getters }, {
    name, ads, status
  }) => {
    commit(types.LOADING, name)
    return getters.apiService.changeAdsStatus({ ads, status })
      .catch(throwError(commit, 'Ошибка приостановления объявлений'))
      .finally(() => commit(types.LOADED, name))
  },

  [types.CHANGE_ADS_STATUS_FROM_ACTION_LOG]: ({ commit, getters }, {
    name, criterions
  }) => {
    commit(types.LOADING, name)
    return getters.apiService.changeAdsStatusFromActionLog({ criterions })
      .catch(throwError(commit, 'Ошибка изменения статуса объявлений из Журнала действий'))
      .finally(() => commit(types.LOADED, name))
  },


  // EXCEPTION ADS
  [types.FETCH_EXCEPTION_ADS]: ({ commit, getters }, {
    during, startDate, endDate, page, limit, filterType, sortProp, sortOrder
  }) => {
    const name = types.EXCEPTION_ADS
    const sort = sortProps[sortProp] || toSnakeCaseString(sortProp)
    const reverse = sortOrder === 'descending'
    const options = {
      during,
      start_date: startDate,
      end_date: endDate,
      page,
      limit,
      filter_type: filterType,
      sort,
      reverse
    }

    commit(types.LOADING, name)
    return getters.apiService.fetchExceptionAds(options)
      .then(({
        isValidConversions, list, totalPage
      }) => {
        commit(types.SET_LIST, { name, list })
        commit(types.UPDATE_PARAMS, { name, params: { totalPage, isValidConversions } })
      })
      .catch(throwError(commit, 'Ошибка получения списка исключений объявлений'))
      .finally(() => commit(types.LOADED, name))
  },


  [types.CHANGE_EXCEPTION_ADS]: ({ commit, getters }, { ads, during, action }) => {
    commit(types.LOADING, types.EXCEPTION_ADS)
    return getters.apiService.changeExceptionAds({ ads, during, action })
      .catch(throwError(commit, 'Ошибка изменения списка исключений объявлений'))
      .finally(() => commit(types.LOADED, types.EXCEPTION_ADS))
  }
}
